import script from "./PriceHistogramSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./PriceHistogramSlider.vue?vue&type=script&setup=true&lang=js"

import "./PriceHistogramSlider.vue?vue&type=style&index=0&id=6ea26772&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ea26772"]])

export default __exports__